import Loadable from '../../components/loadable';

const MembershipInterruptionsMobileFilerModal = Loadable({
  loader: () =>
    import(
      '../../pages/contacts/membership_interruptions/membership_interruption_list_mobile_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('MembershipInterruptionsMobileFilerModal', MembershipInterruptionsMobileFilerModal);
